import { type ReactNode } from 'react';

import { Empty } from '../../empty/Empty';
import { Loading } from '../../loading/Loading';
import { Box, type BoxProps } from '../../structural/Box';

export interface GenericListItemsContainerProps extends Omit<
  BoxProps,
  'height' | 'maxHeight' | 'position'
> {
  readonly emptyContent?: ReactNode;
  readonly isEmpty?: boolean;
  readonly isLoading?: boolean;
}

export const GenericListItemsContainer = ({
  children,
  emptyContent,
  isEmpty = false,
  isLoading = false,
  ref,
  ...props
}: GenericListItemsContainerProps) => (
  <Box {...props} maxHeight='100%' position='relative' ref={ref}>
    <Loading isLoading={isLoading} isOverlay>
      <Empty fallback={emptyContent} isEmpty={isEmpty}>
        {children}
      </Empty>
    </Loading>
  </Box>
);
